import { GenericObject } from "utility/misc";

export default function redirectToTinesWebhookConnectPage(
  orgStore: GenericObject,
  navigate: Function
): void {
  navigate("/environment/destinations/tines_webhook/connect");
}
